import EmbedCode from 'FormsCommonComponents/EmbedCode';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import AppLink from 'ui-forms-components/links/AppLink';
import useGetFormMetadata from 'asset-actions-lib-forms/share/hooks/useGetFormMetadata';
import useIsRenderRawHtmlEnabled from 'asset-actions-lib-forms/share/hooks/useIsRenderRawHtmlEnabled';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import useShouldRenderFormsNextV2 from 'asset-actions-lib-forms/share/hooks/useShouldRenderFormsNextV2';
import useHasFormV2Scope from 'asset-actions-lib-forms/share/hooks/useHasFormV2Scope';
import { getV2EditorRoute } from 'asset-actions-lib-forms/utils/urlUtils';
import { useFetchSfdcSettings } from 'asset-actions-lib-forms/share/hooks/useFetchSfdcSettings';
import { jsx as _jsx } from "react/jsx-runtime";
function CustomCssDisabledTitle({
  isRenderRawHtmlEnabled
}) {
  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: isRenderRawHtmlEnabled ? 'assetActionsLibForms.modals.shareDialog.embedCode.formStyleNotApplied' : 'assetActionsLibForms.modals.shareDialog.embedCode.formStyleApplied'
  });
}
function RawHtmlMessage({
  formGuid,
  isRenderRawHtmlEnabled,
  onClose
}) {
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: isRenderRawHtmlEnabled ? 'assetActionsLibForms.modals.shareDialog.embedCode.disableRawHtml' : 'assetActionsLibForms.modals.shareDialog.embedCode.enableRawHtml',
    options: {
      optionsLink: /*#__PURE__*/_jsx(AppLink, {
        onClick: onClose,
        href: getV2EditorRoute(formGuid, 'options'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "assetActionsLibForms.modals.shareDialog.embedCode.steps.options"
        })
      })
    }
  });
}
export default function EmbedCodeContainer({
  embedVersion,
  formGuid,
  formName,
  onClose,
  onCopy
}) {
  const {
    isSfdcSyncEnabled
  } = useFetchSfdcSettings();
  const getFormMetadata = useGetFormMetadata(formGuid);
  const customCssEnabled = getFormMetadata('css');
  const sfdcCampaignId = getFormMetadata('sfdcCampaignId');
  const isV3Form = embedVersion === EmbedVersions.V3;
  const isV4Form = embedVersion === EmbedVersions.V4;
  const shouldRenderFormsNextV2 = useShouldRenderFormsNextV2();
  const hasFormV2Scope = useHasFormV2Scope();
  const isRenderRawHtmlEnabled = useIsRenderRawHtmlEnabled(formGuid);
  return /*#__PURE__*/_jsx(EmbedCode, {
    customCssEnabled: customCssEnabled === 'true',
    selectedCampaignId: sfdcCampaignId,
    formGuid: formGuid,
    shouldRenderFormsNextV2: shouldRenderFormsNextV2,
    formName: formName,
    onCopy: onCopy
    // not used in dashboard pages
    ,
    toggleCustomCss: () => {},
    showDefaultStyling: hasFormV2Scope,
    isCustomCssDisabled: true,
    isV3Form: isV3Form,
    isV4Form: isV4Form,
    isSfdcSyncEnabled: isSfdcSyncEnabled,
    customCssDisabledTitle: /*#__PURE__*/_jsx(CustomCssDisabledTitle, {
      isRenderRawHtmlEnabled: isRenderRawHtmlEnabled
    }),
    customCssDisabledTooltipTitle: /*#__PURE__*/_jsx(RawHtmlMessage, {
      formGuid: formGuid,
      isRenderRawHtmlEnabled: isRenderRawHtmlEnabled,
      onClose: onClose
    })
  });
}